import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import ChangePassword from './pages/ChangePassword/ChangePassword';
import Catalogs from './pages/Catalogs/Catalogs';
import AdminDashboard from './pages/AdminDashboard/AdminDashboard';
import AdminUsers from './pages/AdminUsers/AdminUsers';
import GlobalNotifications from './pages/GlobalNotifications/GlobalNotifications';
import Logs from './pages/Logs/Logs';
import TimeLogPermissions from './pages/TimeLogPermissions/TimeLogPermissions';
import Requirements from './pages/Requirements/Requirements';
import Reports from './pages/Reports/Reports';
import Activities from './pages/Activities/Activities';
import RequirementsDashboard from './pages/RequirementsDashboard/RequirementsDashboard';
import AccessDenied from './pages/AccessDenied/AccessDenied';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import ProtectedRoute from './components/ProtectedRoute';
import RoleProtectedRoute from './components/RoleProtectedRoute';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
        <Route
          path="/catalogs"
          element={
            <RoleProtectedRoute allowedRoles={['Gerente', 'Líder']}>
              <Catalogs />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <RoleProtectedRoute allowedRoles={['Gerente']}>
              <AdminDashboard />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/admin-users"
          element={
            <RoleProtectedRoute allowedRoles={['Gerente']}>
              <AdminUsers />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/admin-notifications"
          element={
            <RoleProtectedRoute allowedRoles={['Gerente']}>
              <GlobalNotifications />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/admin-logs"
          element={
            <RoleProtectedRoute allowedRoles={['Gerente']}>
              <Logs />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/admin-timelog-permissions"
          element={
            <RoleProtectedRoute allowedRoles={['Gerente']}>
              <TimeLogPermissions />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/requirements"
          element={
            <ProtectedRoute>
              <Requirements />
            </ProtectedRoute>
          }
        />
        <Route
          path="/activities"
          element={
            <ProtectedRoute>
              <Activities />
            </ProtectedRoute>
          }
        />
        <Route
          path="/activities/report"
          element={
            <ProtectedRoute>
              <Activities initialView="report" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <RoleProtectedRoute allowedRoles={['Gerente', 'Líder']}>
              <Reports />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/reports/activities"
          element={
            <RoleProtectedRoute allowedRoles={['Gerente', 'Líder']}>
              <Reports initialView="activities" />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/reports/weekly"
          element={
            <RoleProtectedRoute allowedRoles={['Gerente', 'Líder']}>
              <Reports initialView="weekly" />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/requirements-dashboard"
          element={
            <ProtectedRoute>
              <RequirementsDashboard />
            </ProtectedRoute>
          }
        />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/access-denied" element={<ProtectedRoute><AccessDenied /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
